import { useOutletContext } from 'react-router-dom';

import type { ShellContext } from '@/components/layout/AppShell';
import { Board } from '@/components/tasks/Board';
import { useT } from '@/lib/i18n';
import { Page } from '@/routes/Today';

/** Every task of yours, arranged by the stage it is in. */
export function BoardRoute() {
  const t = useT();
  const { openTask } = useOutletContext<ShellContext>();
  return (
    <Page>
      <h1 className="mb-1 text-xl font-semibold tracking-tight">{t('board.title')}</h1>
      <p className="mb-5 text-sm text-content-subtle">{t('board.hint')}</p>
      <Board onOpenTask={openTask} />
    </Page>
  );
}
